import { render } from "./DynamicLabel.vue?vue&type=template&id=d3b0e966&ts=true"
import script from "./DynamicLabel.vue?vue&type=script&lang=ts"
export * from "./DynamicLabel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3b0e966"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3b0e966', __exports__)) {
    api.reload('d3b0e966', __exports__)
  }
  
  module.hot.accept("./DynamicLabel.vue?vue&type=template&id=d3b0e966&ts=true", () => {
    api.rerender('d3b0e966', render)
  })

}


export default __exports__